import React, { ReactNode } from 'react';
import { NO_DATA } from 'constants/common';
import { DeleteOutline, Edit } from '@mui/icons-material';
import { Box, Stack, Typography, Divider, Button, IconButton } from '@mui/material';

import { useCalendar } from '../../api';
import { CalendarEventCardProps } from '../../types';
import { DueCell, StatusCell, AccountCell, EventTypeCell } from '../table/cells';

export const CalendarEventInfo = ({ event, onSwitchMode }: CalendarEventCardProps) => {
  const { handleCompleteEvent, handleDeleteEvent } = useCalendar();

  const fields: { label: string; content: ReactNode; fullWidth?: boolean }[] = [
    { label: 'Account', content: <AccountCell account={event.account?.name ?? null} /> },
    { label: 'Type', content: <EventTypeCell type={event.eventType} /> },
    { label: 'Due', content: <DueCell due={event.due ?? null} /> },
    { label: 'Status', content: <StatusCell status={event.activityStatus} /> },
    { label: 'Notes', fullWidth: true, content: <Typography variant="body2">{event.notes || NO_DATA}</Typography> },
  ];

  return (
    <>
      <Stack height="100%" direction="column" gap="0.5rem">
        <Stack direction="column">
          <Typography color="text.secondary">Activity</Typography>

          <Typography variant="h6" fontWeight="bold" textTransform="none">
            Event {event.subject}
          </Typography>
        </Stack>

        <Divider sx={{ borderColor: 'divider' }} />

        <Box sx={{ display: 'grid', gap: '1rem', gridTemplateColumns: '1fr 1fr' }}>
          {fields.map(({ label, content, fullWidth }) => (
            <Stack key={label} gap="0.25rem" sx={{ gridColumn: fullWidth ? '1 / -1' : 'auto' }}>
              <Typography variant="caption" color="text.secondary" textTransform="uppercase">
                {label}
              </Typography>

              {content}
            </Stack>
          ))}
        </Box>
      </Stack>

      <Stack direction="row" gap="1rem" width="100%">
        <Button variant="contained" onClick={() => handleCompleteEvent([event.id])}>
          Complete
        </Button>

        <IconButton className="icon-btn-bordered" onClick={onSwitchMode}>
          <Edit color="primary" />
        </IconButton>

        <IconButton color="error" className="icon-btn-bordered" onClick={() => handleDeleteEvent([event.id])}>
          <DeleteOutline />
        </IconButton>
      </Stack>
    </>
  );
};
